module.exports = __webpack_public_path__ + "static/media/sd5050.8c518faf.mp3";